import React, { useState, useEffect } from 'react'
import { Spin, Button, notification, Alert } from 'antd'
import {
  getPoolFinalizedStatus,
  finalizedPool,
  finalizedPoolForBEP20Tokens
} from '../../../Blockchain/services/presale.service'
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useAccount, useSigner } from 'wagmi';

export default function FinalizedPoolButton(props) {

  const { t } = useTranslation();
  const { isPoolStatusLoading, poolStatus, presaleAddress, presaleSaleDetails } = props

  const [canFinalizedThePool, setCanFinalizedThePool] = useState(false)
  const [isFinalizedPoolLoading, setIsFinalizedPoolLoading] = useState(false)
  const [isPoolFinalized, setIsPoolFinalized] = useState(false)
  const [poolButtonText, setPoolButtonText] = useState('Finalize Presale')
  const { address: account } = useAccount();
  const { data: signer } = useSigner();

  const key = 'updatable';

  useEffect(() => {
    if (poolStatus) {
      if (poolStatus?.statusCode === 'ended' || poolStatus?.statusCode === 'filled') {
        setCanFinalizedThePool(true)
      } else {
        setCanFinalizedThePool(false)
      }
    } else {
      setCanFinalizedThePool(false)
    }
  }, [poolStatus])

  useEffect(() => {
    if (presaleAddress) {
      fetchPoolFinalizeStatus()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presaleAddress])

  const fetchPoolFinalizeStatus = async () => {
    try {
      const poolFinalizedResponse = await getPoolFinalizedStatus(presaleAddress)
      if (poolFinalizedResponse && poolFinalizedResponse.isPoolFinalized) {
        setIsPoolFinalized(true)
        setPoolButtonText(t('Pool has been finalized'))
      } else {
        setIsPoolFinalized(false)
        setPoolButtonText('Finalize Presale')
      }
    } catch (error) {
      console.error("ERROR while fetching pool finalize status ", error)
      setIsPoolFinalized(false)
    }
  }

  const handleFinalizedPool = async () => {
    try {

      if (!account) {
        notification['error']({
          key,
          message: t('Authentication Error'),
          description:
            t('Please connect your wallet to proceed'),
        });
        setIsFinalizedPoolLoading(false)
        return
      }

      setIsFinalizedPoolLoading(true)
      let response
      if (presaleSaleDetails?.liquidityTokenName === 'BNB') {
        response = await finalizedPool(presaleAddress, signer)
      } else {
        response = await finalizedPoolForBEP20Tokens(presaleAddress, signer)
      }

      if (response) {
        const endpoint = `${process.env.REACT_APP_API_BASE_URL}/api/v1/liquidity-locker/sync-lock-records`
        const dbResponse = axios.get(endpoint)
        console.log("dbResponse ", dbResponse)
      }

      console.log("response finalized", response)
      setIsFinalizedPoolLoading(false)
      await fetchPoolFinalizeStatus()
      notification['success']({
        key,
        message: t('Success'),
        description: t('Success. Presale has been finalised.'),
      });
    } catch (error) {
      setIsFinalizedPoolLoading(false)
      console.error("ERROR while finalizing  the private sale pool ", error)
      notification['error']({
        key,
        message: t('Transaction failed, review and try again.'),
        description: error,
      });

    }
  }

  return (
    <div className='finalized-pool-button-container'>

      {
        isPoolStatusLoading ? (
          <div className='loader text-centered'>
            <Spin size='small' />
          </div>
        ) : (
          <>
            <Alert message="Please remember to exclude the presale address from the fees." type="info" className='text-center' />
            <Button
              className='mt-2'
              loading={isFinalizedPoolLoading}
              disabled={!canFinalizedThePool || isPoolFinalized}
              onClick={handleFinalizedPool}
              block
              type="primary">
              {poolButtonText}
            </Button>
          </>
        )
      }

    </div>
  )
}
